import { Action } from '../index';

type IStep = 'step1' | 'step2' | 'step3' | 'step4' | 'step5';

export interface IRecipient {
    current: boolean;
    email: string;
    firstName: string;
    lastName: string;
    teamLeader: boolean | null;
}

interface ITeamScanData {
    emails: string;
    industry: string | null;
    myLink: string | null;
    organisationSize: string | null;
    recipients: IRecipient[];
    sendMessage: string | null;
    step: IStep;
    resendRecipients: {
        id: string;
        email: string;
    }[];
    msg: {
        title: string;
        body: string;
    };
}

export interface ITeamScanState {
    [index: string]: ITeamScanData;
}

function defaultData(): ITeamScanData {
    return {
        emails: '',
        industry: '',
        msg: {
            body: '',
            title: '',
        },
        myLink: null,
        organisationSize: '',
        recipients: [],
        resendRecipients: [],
        sendMessage: null,
        step: 'step1',
    };
}

const initialState: ITeamScanState = {};

export function reducer(state: ITeamScanState = initialState, action: Action): ITeamScanState {
    switch (action.type) {
        case 'INIT_TEAM_SCAN':
            return {
                ...state,
                [action.id]: {
                    ...defaultData(),
                    ...state[action.id],
                },
            };
        case 'TO_STEP_2':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    emails: action.emails,
                    industry: action.industry,
                    organisationSize: action.organisationSize,
                    recipients: action.recipients,
                    step: 'step2',
                },
            };
        case 'TO_STEP_3':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    recipients: action.recipients,
                    step: 'step3',
                },
            };
        case 'TO_STEP_4':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    msg: {
                        body: action.body,
                        title: action.title,
                    },
                    step: 'step4',
                },
            };
        case 'TO_STEP_5':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    emails: '',
                    industry: '',
                    msg: {
                        body: '',
                        title: '',
                    },
                    myLink: action.myLink,
                    organisationSize: '',
                    recipients: [],
                    step: 'step5',
                },
            };
        case 'BACK_TO_STEP':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    step: action.step,
                },
            };
        case 'SET_RESEND_RECIPIENTS':
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    resendRecipients: action.resendRecipients,
                },
            };
        default:
            return state;
    }
}
